document.addEventListener("DOMContentLoaded", function () {
  function copyToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log("Text copied to clipboard");
        copyButton.style.backgroundColor = isCopied ? "#ff8933" : "#FF9C54";
        copyButton.innerText = isCopied ? "Copy" : "Copied!";
        isCopied = !isCopied;
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  }

  function updateDiscountedPrice(e) {
    const productQuantity = parseFloat(e.target.value) || 0;
    const discountPriceElem = document.querySelector(".discount-price");
    const childPriceElem = document.querySelector(
      ".discount-price .price-item"
    );
    const discountPercent =
      parseFloat(discountPriceElem.dataset.discountPercent) || 0;
    const productPrice =
      (parseFloat(discountPriceElem.dataset.productPrice) || 0) / 100;

    const discountPercentVal = discountPercent / 100;
    const discountAmount = productPrice * productQuantity * discountPercentVal;
    const finalPrice = productPrice * productQuantity - discountAmount;
    childPriceElem.innerText = `$${finalPrice} SGD`;
  }

  const quantityInput = document.querySelector('input[name="quantity"]');

  const copyButton = document.querySelector(".copy-button");
  const discountCode = document.querySelector(".discount-code");
  let isCopied = false; // Track the state of the button

  copyButton.addEventListener("click", function () {
    const textToCopy = discountCode.textContent;
    copyToClipboard(textToCopy);
  });

  // Listen for quantity changes
  quantityInput.addEventListener("input", updateDiscountedPrice);
  quantityInput.addEventListener("change", updateDiscountedPrice);
  updateDiscountedPrice();
});
